import { theme } from '../globalStyle/global-styles';
import styled from 'styled-components';

export const DeleteButtonContainer = styled.div`
  padding-top: 16px;
  display: flex;
  align-items: center;
  justify-content:center;
  gap: 10px;
  width:100%;

  button {
    border-radius: 8px;
    font-family: ${theme.fonts.Medium};
    background-color: ${theme.colours.blackText};
    color: ${theme.colours.white};
    width: 86px;
    height: 36px;
    font-size: 14px;
    font-weight: 400;
    &:hover {
      background-color: ${theme.colours.blackText};
    }
    &[type='button'] {
      background-color: ${theme.colours.blackText};
      color: ${theme.colours.white};
    }
    &[type='reset'] {
      background-color: ${theme.colours.white};
      color: ${theme.colours.blackText};
      border: 1px solid ${theme.colours.newOutline};
    }
  }
`;
